<template>
	<div class="vx-card col-span-2 p-6 flex flex-col">

		<div class="grid grid-cols-2 gap-4 mb-6">
			<div>
				<h2 class="mb-8 text-4xl truncate NOTwhitespace-nowrap">Overall Score</h2>
				<!--{{ ship.cluster.overall_score }}-->
				<!--<div class="flex justify-between items-center" v-if="ship">
					<vs-progress :percent="ship.cluster.overall_score * 20" color="primary" />
				</div>-->
				
				<div class="mr-4">
					<vue-apex-charts
						height="172"
						:options="chartOptions"
						:series="chartSeries"
					/>
				</div>

			</div>
			<div>

				<ship-review-overall-hits-misses
					:ship="ship"
				/>
				
			</div>
		</div>

		<div class="mt-auto">
			<ship-review-overall-categories-scorings
					:ship="ship"
				/>
		</div>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ShipReviewOverallHitsMisses from "@/components/cat/ShipReviewOverallHitsMisses.vue";
import ShipReviewOverallCategoriesScorings from "@/components/cat/ShipReviewOverallCategoriesScorings.vue";

export default {
    props: {
        ship: {
            type: Object,
            required: true
        }
    },
	computed: {
		chartSeries() {
			return [
				{
					data: [
						{
							x: "overall",
							y: this.ship.cluster.overall_score.replace(',', '.')*1,
							goals: [
								{
									name: "Expected",
									value: this.ship.cluster_benchmark.overall_score.replace(',', '.')*1,
									strokeWidth: 25,
									strokeColor: '#cccccc'
								},
							],
						},
					],
				}
			];
		},
		chartOptions() {
			return {
				stroke: {
					colors: ["transparent"],
					
				},
				yaxis: {
					show: true,
					min: 0,		
					max: 4,		// to do define variable and reuse for tickAmount and formatter!!!
					decimalsInFloat: 1,
					tickAmount: 4,
					text: ['min','','mean','','max'],
					labels: {
						minWidth: 55,
						maxWidth: 55,
						style: {
							colors: '#999999',
							fontSize: '1rem',
							fontFamily: 'Montserrat, Helvetica, Arial, sans-serif'
						},
						formatter: function(val, index) {
							if (index == 0){
								return "Low ("+val+")"
							} else if (index == 4){
								return "High ("+val+")"
							} else {
								return ""
							}
						}
					},
					axisBorder: {
						show: true,
						color: '#d9d9d9',
						width: 1,
						// offsetX: -1,
						// offsetY: 2
					},
				},
				xaxis: {
					labels: {
						show: false,
					},
					axisTicks: {
          				show: false
					},
					axisBorder: {
						show: false,
						height: 1,
						color: '#d90000',
          				width: '100%'
					}
				},
				colors: ['#e44a7f'],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '20%',
						// borderRadius: 2,
					},
				},
				legend: {
					show: false,
				},
				dataLabels: {
					enabled: false,
				},
				chart: {
					type: "bar",
					toolbar: { show: false },
				},
				tooltip: {
					enabled: false,
				},
				states: {
					hover: {
						filter: {
							type: "none",
						},
					},
				},
				grid: {
					padding: {
						top: -20,
						bottom: -10,
						// right: 0
					}
				},
			}
		}
	},
	components: {
		VueApexCharts,
        ShipReviewOverallHitsMisses,
		ShipReviewOverallCategoriesScorings
    }
}
</script>